import { render, staticRenderFns } from "./PanelCreateMedia.vue?vue&type=template&id=1532ee10&"
import script from "./PanelCreateMedia.vue?vue&type=script&lang=js&"
export * from "./PanelCreateMedia.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports